import { TranslationMap } from '@trimble-gcs/i18n-types';

export function clarityFilePickerTranslations() {
  return {
    title: {
      text: $localize`:@@import.dialog.picker.clarity.title:Import File(s) From Clarity`,
      desc: 'Title for the Clarity file picker dialog.',
    },
    close: {
      tooltip: {
        text: $localize`:@@import.dialog.picker.clarity.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the Clarity file picker dialog.',
      },
    },
    worldSelect: {
      text: $localize`:@@import.dialog.picker.clarity.worldSelect:Clarity World`,
      desc: 'Label for the world select dropdown.',
      limit: 20,
    },
    openClarity: {
      text: $localize`:@@import.dialog.picker.clarity.openClarity:Open Clarity`,
      desc: 'Anchor text for link that opens the Clarity site in a new browser tab.',
      limit: 20,
    },
    selectedQty: {
      '=1': {
        text: $localize`:@@import.dialog.picker.clarity.selectedOne:1 file selected`,
        desc: 'Text to display when user has one file selected.',
      },
      other: {
        text: $localize`:@@import.dialog.picker.clarity.selectedMany:{count} files selected`,
        desc: 'Text to display when user has more than one file selected.',
      },
    },
    errorGettingFileInfo: {
      text: $localize`:@@import.dialog.picker.clarity.errorGettingFileInfo:Error getting file information`,
      desc: 'Error message displayed when file info could not be retrieved.',
    },
    cancel: {
      text: $localize`:@@import.dialog.picker.clarity.cancel:Cancel`,
      desc: 'Button text to close and dismiss the Clarity file picker dialog.',
    },
    next: {
      text: $localize`:@@import.dialog.picker.clarity.next:Next`,
      desc: 'Button text to continue after selection has been made.',
    },
  } satisfies TranslationMap;
}
